/* Apollo motion: scroll-reveal (home + product) + accordion expand/collapse. Dependency-free; respects reduced-motion. */
(function(){
  var b = document.body;
  if (!b) return;
  var isHome = b.classList.contains('template--index');
  var isProduct = b.classList.contains('template--product');
  if (!isHome && !isProduct) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Accordion: smooth height animation + exclusive (one open at a time). ---- */
  function clearWatch(body){
    if (body._amTE) { body.removeEventListener('transitionend', body._amTE); body._amTE = null; }
    if (body._amTO) { clearTimeout(body._amTO); body._amTO = null; }
  }
  function finalize(item, body, opening){
    clearWatch(body);
    if (!opening) item.open = false;
    body.style.height = '';
  }
  function watch(item, body, opening){
    body._amTE = function te(ev){ if (ev.target !== body || ev.propertyName !== 'height') return; finalize(item, body, opening); };
    body.addEventListener('transitionend', body._amTE);
    /* Fallback: guarantees the final logical state even if the transition is throttled (e.g. background tab). */
    body._amTO = setTimeout(function(){ finalize(item, body, opening); }, 620);
  }
  function openItem(item){
    var body = item.querySelector('.apollo-acc__body');
    if (!body) return;
    if (reduce) { item.open = true; return; }
    clearWatch(body);
    item.open = true;
    var target = body.scrollHeight;
    body.style.height = '0px';
    body.getBoundingClientRect();          /* commit start without rAF */
    body.style.height = target + 'px';     /* triggers transition to full */
    watch(item, body, true);
  }
  function closeItem(item){
    var body = item.querySelector('.apollo-acc__body');
    if (!body || !item.open) return;
    if (reduce) { item.open = false; return; }
    clearWatch(body);
    body.style.height = body.offsetHeight + 'px';
    body.getBoundingClientRect();          /* commit start without rAF */
    body.style.height = '0px';             /* triggers transition to 0 */
    watch(item, body, false);
  }
  function initAccordions(){
    var groups = document.querySelectorAll('.apollo-acc');
    Array.prototype.forEach.call(groups, function(group){
      if (group.classList.contains('js-acc-bound')) return;
      group.classList.add('js-acc-bound');
      group.classList.add('js-acc');
      var items = [].slice.call(group.querySelectorAll('.apollo-acc__item'));
      items.forEach(function(item){
        var summary = item.querySelector('summary');
        if (!summary) return;
        summary.addEventListener('click', function(e){
          e.preventDefault();
          if (item.open) {
            closeItem(item);
          } else {
            items.forEach(function(other){ if (other !== item && other.open) closeItem(other); });
            openItem(item);
          }
        });
      });
    });
  }
  initAccordions();

  /* ---- Scroll reveal ---- */
  if (reduce) return;
  if (!('IntersectionObserver' in window)) return;
  b.classList.add('apollo-motion');
  var main = document.getElementById('MainContent') || document.querySelector('main') || b;
  var targets = [];
  function mark(el, delay){ if(!el || el.classList.contains('am-reveal')) return; el.classList.add('am-reveal'); if(delay) el.style.transitionDelay = delay + 's'; targets.push(el); }
  var sections = main.querySelectorAll('.shopify-section');
  Array.prototype.forEach.call(sections, function(sec){
    var isMainProduct = sec.querySelector('.main-product, [class*="main-product"]');
    var cards = sec.querySelectorAll('.product-card');
    if (isMainProduct) {
      var pieces = sec.querySelectorAll('.apollo-trust, .apollo-specs, .apollo-acc__item, .apollo-dims');
      Array.prototype.forEach.call(pieces, function(p, i){ mark(p, (i % 4) * 0.06); });
    } else if (cards.length) {
      Array.prototype.forEach.call(cards, function(c, i){ mark(c, (i % 4) * 0.08); });
    } else {
      mark(sec, 0);
    }
  });
  if (!targets.length) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
  targets.forEach(function(t){ io.observe(t); });
})();

/* ---- Collection filter labels: relabel Shopify's default English base labels to French (FR storefront only). ---- */
(function(){
  var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
  if (lang.indexOf('fr') !== 0) return;
  var MAP = { 'Availability': 'Disponibilité', 'Price': 'Prix' };
  function relabel(root){
    var btns = (root || document).querySelectorAll('.facets__accordion-btn');
    Array.prototype.forEach.call(btns, function(btn){
      Array.prototype.forEach.call(btn.childNodes, function(n){
        if (n.nodeType === 3) {
          var t = n.textContent.trim();
          if (t && MAP[t]) { n.textContent = n.textContent.replace(t, MAP[t]); }
        }
      });
    });
  }
  relabel(document);
  /* Re-apply after AJAX filter updates re-render the facets. */
  var host = document.querySelector('#main-collection-filters, .facets-wrapper, .facets, form[data-filters], #FacetFiltersForm') || document.body;
  if (window.MutationObserver && host) {
    var obs = new MutationObserver(function(muts){
      for (var i=0;i<muts.length;i++){ if (muts[i].addedNodes && muts[i].addedNodes.length){ relabel(document); break; } }
    });
    obs.observe(host, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', function(){ relabel(document); });
})();

/* ---- Espace Opticien (partner) page: scroll-reveal animation (this page isn't home/product, so handled separately). ---- */
(function(){
  var sec = document.getElementById('shopify-section-template--18556779495518__main');
  if (!sec) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;
  document.body.classList.add('apollo-motion');
  var targets = [];
  function mark(el, delay){
    if (!el || el.classList.contains('am-reveal')) return;
    el.classList.add('am-reveal');
    if (delay) el.style.transitionDelay = delay + 's';
    targets.push(el);
  }
  var content = sec.querySelector('.main-page__content');
  mark(sec.querySelector('.main-page__title'), 0);
  if (content) {
    mark(content.querySelector('h1'), 0.05);
    mark(content.querySelector('h1 + p'), 0.1);
    Array.prototype.forEach.call(content.querySelectorAll('h3'), function(h){ mark(h, 0); });
    Array.prototype.forEach.call(content.querySelectorAll('h3 + p'), function(p){ mark(p, 0.05); });
    Array.prototype.forEach.call(content.querySelectorAll('ul li'), function(li, i){ mark(li, (i % 2) * 0.08); });
    Array.prototype.forEach.call(content.querySelectorAll('ol li'), function(li, i){ mark(li, (i % 4) * 0.08); });
  }
  if (!targets.length) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
  targets.forEach(function(t){ io.observe(t); });
})();
